/* Environment */
export const DNS = 'https://0e38b8e12b814f4ab27a249075c5f36b@weblog.mspbackups.com/3';
export const MBS_MODE = 'https://apps-stage.mspbackups.com';
export const STANDALONE_MODE = {
  dev: 'https://scloud.resale-stage.mspbackups.com',
  prod: 'https://apps.msp360.com'
} as const;

/* Layout */
export const HEADER_HEIGHT = 40;
export const FOOTER_HEIGHT = 100;
export const MBS_PAGE_CONTENT_PAD_TOP = 14;
export const MBS_PAGE_CONTENT_PAD_BOTTON = 21;
export const MIN_SCREEN_HEIGHT = 650;

/* Constants */
export const BODY_OPEN_CLASS = 'mbs-select-checkbox-one-line-opened';
export const BREAKPOINT = '--bs-breakpoint-';
export const DEFAULT_NAME_SORT = 'Name asc';
export const NAVBAR_BREAKPOINT = '--navbar-breakpoint-';
export const MIN_SAFARI_VERSION = '16.4';
export const NO_LICENSES_AVAILABLE_ERROR_DETAIL = 'NoLicensesAvailable';
export const RESTORE_MIN_DATE = '2015-01-01';
export const SECRET_KEY_MASK = '********************';
export const TABLE_MIN_HEIGHT = '253px';
export const TEXT_OVERFLOW = 'text-overflow';

/* Theme */
export const CSS_VAR_BORDER = '--mbs-border';
export const CSS_VAR_TEXT = '--mbs-text';
export const DATA_THEME_ATTRIBUTE = 'data-bs-theme';
export const STORAGE_KEY = 'theme';

/* Regex */
export const BASIC_PHONE_PATTERN = /^(?:\+|\(|\d)[\d\s\-().]*$/;
export const DOUBLE_SLASH_REGEX = /([^:]\/)\/+/g;
export const PHONE_REGEX = /^(?:\+1\s?)?(?:\(\d{3}\)|\d{3})[\s\-.]?\d{3}[\s\-.]?\d{4}(?:\s?(?:x|ext\.?)\s?\d+)?$/;
export const PHONE_REGEX_SAFARI = /^(?:\+1\s?)?(?:\(\d{3}\)|\d{3})[\s\-.]?\d{3}[\s\-.]?\d{4}(?:\s?(?:x|ext\.?)\s?\d+)?$/;
export const SINGLE_QUOTES_REGEX = /(^')|('$)/g;
export const UNIVERSAL_PHONE_REGEX = /^(?=(.*\d){8,15}$)(?:\+[1-9]\d*|\(\d+\)|\d)[\d\-().\s]*$/;
export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/* Other */
export const APPEND_BUTTON_PASSWORD_STATE = {
  visible: {
    icon: 'fa fa-eye-slash',
    type: 'text'
  },
  hidden: {
    icon: 'fa fa-eye',
    type: 'password'
  }
};

export const STANDALONE_ICON = {
  logo: `assets/standalone/logo.jpg`,
  favicon: `assets/standalone/favicon-std.svg`
};
